import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAccountStore } from "@/common/store/accountStore";
import { loginApi } from "@/pages/login/api/loginApi";

/**
 * 앱 재로드(새로고침) 후에도 role/affiliation.type 이 최신이도록 my-info 를 재조회한다.
 *
 * persist 로 복원된 user_info 는 초기 표시용이고, 이 쿼리 결과가 authoritative.
 * 실패는 전역 throwOnError 정책을 그대로 타서 PageErrorBoundary 가 처리한다.
 */
export function useSyncMyInfo() {
  const accessToken = useAccountStore((s) => s.access_token);
  const setUserInfo = useAccountStore((s) => s.setUserInfo);

  const { data } = useQuery({
    queryKey: ["myInfo"],
    queryFn: loginApi.info,
    enabled: !!accessToken,
  });

  useEffect(() => {
    if (data) setUserInfo(data);
  }, [data, setUserInfo]);
}
